// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"68":"component---src-pages-instrucoes-js","351":"commons","678":"component---src-pages-index-js"}[chunkId] + "-" + {"68":"8dd79a1e374d6a8368a1","351":"68ff81e67fa571955bf0","678":"f46ed4fce31e501c9f32"}[chunkId] + ".js";
};